module.exports = __webpack_public_path__ + "static/media/pierrebartholomeus.6d713183.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/pierrebartholomeus.webp
// module id = 724
// module chunks = 0